var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    _vm._l(_vm.paymentCards, function (card) {
      return _c(
        "li",
        { key: card.id, staticClass: "list-none" },
        [
          _c("PaymentCard", {
            attrs: {
              brand: card.brand,
              cardId: card.id,
              expMonth: card.exp_month,
              expYear: card.exp_year,
              last4: card.last4,
              updatedAt: card.updated_at,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "actions",
                  fn: function ({ isExpired }) {
                    return [
                      !isExpired
                        ? _c("UIButton", {
                            attrs: {
                              buttonText: "Choose",
                              variant: "secondary",
                              processing: _vm.processing,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("chooseCard", card.id)
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }